import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

import Filter from "../../components/elements/Filter";
import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import { getCountries, getUsers } from "../../store/middleware";
import { decryptIfEncrypted } from "../../utils/fieldDecryptor";
import iconeUsersSVG from "../../assets/images/icons/icon_users_header.svg";

import { TableUser } from "./styles";
import PlaceholderText from "../../components/Placeholder/PlaceholderText";

function Users() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { usersManagement } = useSelector((state) => state.companyManagerReducer);

  const [countries, setCountries] = useState([]);
  const [filter, setFilter] = useState({
    name: "",
    login: "",
    active: "",
    country: "",
    profiles: "",
  });

  const filters = [
    {
      type: "text",
      placeholder: "User name",
      name: "name",
      label: "Name",
      value: filter.name,
    },
    {
      type: "text",
      placeholder: "Login",
      name: "login",
      label: "Login",
      value: filter.login,
    },
    {
      type: "select",
      placeholder: "Select",
      name: "profiles",
      label: "Profile",
      value: filter.profiles,
      options: [
        { id: "customerService", name: "Customer Service" },
        { id: "companyManager", name: "Company Manager" },
        { id: "b2b", name: "B2B" },
      ],
    },
    {
      type: "select",
      placeholder: "Select",
      name: "country",
      label: "Country",
      options: countries,
      value: filter.country,
    },
    {
      type: "select",
      placeholder: "Select",
      name: "active",
      label: "Status",
      value: filter.active,
      options: [
        { id: 1, name: "Active" },
        { id: 0, name: "Inactive" },
      ],
    },
  ];

  const getData = () => {
    dispatch(getUsers());
    dispatch(getCountries()).then((res) => setCountries(res));
  };

  const applyFilters = () => {
    let newFilter = "?skip=0&take=255";
    newFilter += filter.name !== "" ? `&name=${filter.name}` : "";
    newFilter += filter.login !== "" ? `&login=${filter.login}` : "";
    newFilter += filter.profiles !== "" ? `&profileId=${filter.profiles}` : "";
    newFilter += filter.country !== "" ? `&countryId=${filter.country}` : "";
    newFilter += filter.active !== "" ? `&active=${filter.active === "1" ? true : false}` : "";

    dispatch(getUsers(newFilter));
  };

  const resetFilter = () => {
    setFilter({
      name: "",
      login: "",
      active: "",
      country: "",
      profiles: "",
    });
    dispatch(getUsers());
  };

  const inputChange = (e) => {
    const { value, name } = e.target;
    setFilter((state) => ({ ...state, [name]: value.trim() }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="view">
      <SideMenu />
      <section>
        <Header
          title={t("USERS")}
          icon={<img src={iconeUsersSVG} alt="iconeUsersSVG" />}
          typeIcon="custom"
          rightButton={
            <button className="buttonRight" onClick={() => navigate("/users/new")}>
              <i className="fa fa-plus" aria-hidden="true" />
              Add new User
            </button>
          }
          t={t}
        />

        <div className="content">
          <Filter filters={filters} inputChange={inputChange} submit={applyFilters} clear={resetFilter} />

          {usersManagement?.length > 0 ? (
            <TableUser>
              <div className="bigBoxTableUsers">
                <table>
                  <tbody>
                    <tr>
                      <th>Name</th>
                      <th>Login</th>
                      <th>Profile</th>
                      <th>Country</th>
                      <th>Status</th>
                      <th style={{ textAlign: "center" }}>Option</th>
                    </tr>

                    {usersManagement?.map((item) => (
                      <tr key={item.id}>
                        <td>{decryptIfEncrypted(item.name)}</td>
                        <td>{decryptIfEncrypted(item.email)}</td>
                        <td>
                          {item.role === "companyManager"
                            ? "Company Manager"
                            : item.role === "customerService"
                            ? "Customer Service"
                            : "B2B"}
                        </td>
                        <td>{decryptIfEncrypted(item.country.name)}</td>
                        <td>
                          <span className={!item.active ? "inativo" : "activo"}>
                            {item.active ? "Active" : "Inactive"}
                          </span>
                        </td>
                        <td>
                          <Link
                            to={{
                              pathname: "/users/" + item.id,
                              state: { info: item },
                            }}
                          >
                            <button>
                              View <i className="fa fa-angle-right" aria-hidden="true"></i>
                            </button>
                          </Link>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </TableUser>
          ) : (
            <PlaceholderText pageName="users" textMsg="No results" />
          )}
        </div>
      </section>
    </div>
  );
}

export default Users;
